class Analytics {
    static get noBranchText() {
        return "no_branch";
    }
    
    constructor() {
        dataLayer.push({
            'contentType': window.pageType, // typ av sidan tex BlockListPage
            'isAuthenticated': String(window.authenticated).charAt(0).toUpperCase() + String(window.authenticated).slice(1).toLowerCase(),
            'selectedBranch': Analytics.getBranchName(),
        });
    }


    static sendEvent(category, action, label) {
        if (typeof ga !== 'undefined') {
            //ga('send', 'event', category, action, label);
        }
    }

    //Favourite
    static addFavourite() {
        dataLayer.push({
            'event': 'favourite',
            'favoritAction': 'Add',
            'isAuthenticated': String(window.authenticated).charAt(0).toUpperCase() + String(window.authenticated).slice(1).toLowerCase(),
            'selectedBranch': Analytics.getBranchName()
        });
    }
    static removeFavourite() {
        dataLayer.push({
            'event': 'favourite',
            'favoritAction': 'Remove',
            'isAuthenticated': String(window.authenticated).charAt(0).toUpperCase() + String(window.authenticated).slice(1).toLowerCase(),
            'selectedBranch': Analytics.getBranchName()
        });
    }

    //Product List
    static orderForm() {
        //Analytics.sendEvent('TF_OrderForm', 'Submit', location.pathname);
    }

    //Event booking
    static bookEvent() {
        dataLayer.push({
            'event': 'eventBooking',
            'eventName': document.title.substr(0, document.title.indexOf(" - Transport")), // bokat event
            'isAuthenticated': String(window.authenticated).charAt(0).toUpperCase() + String(window.authenticated).slice(1).toLowerCase(),
            'selectedBranch': Analytics.getBranchName()
        });

        //this.sendEvent('TF_EventBooking', 'Click', location.pathname);
    }

    static bookEventComplete() {
        dataLayer.push({
            'event': 'eventBookingComplete',
            'eventName': document.title.substr(0, document.title.indexOf(" - Transport")), // bokat event
            'isAuthenticated': String(window.authenticated).charAt(0).toUpperCase() + String(window.authenticated).slice(1).toLowerCase(),
            'selectedBranch': Analytics.getBranchName()
        });
    }

    static getAuthenticated = () => String(window.authenticated).charAt(0).toUpperCase() + String(window.authenticated).slice(1).toLowerCase();

    //Guides
    static renderGuide(txt) {
        dataLayer.push({
            'event': 'guideInteraction',
            'guideTyp': 'Render',
            'guideHeadline': txt, //rubriken som man klickat på
            'isAuthenticated': String(window.authenticated).charAt(0).toUpperCase() + String(window.authenticated).slice(1).toLowerCase(),
            'selectedBranch': Analytics.getBranchName()
        });
    }

    static expandGuide(txt) {
        dataLayer.push({
            'event': 'guideInteraction',
            'guideTyp': 'Expand',
            'guideHeadline': txt, //rubriken som man klickat på
            'isAuthenticated': String(window.authenticated).charAt(0).toUpperCase() + String(window.authenticated).slice(1).toLowerCase(),
            'selectedBranch': Analytics.getBranchName()
        });
    }

    static expandFaq(txt) {
        dataLayer.push({
            'event': 'faqInteraction',
            'guideTyp': 'Expand',
            'guideHeadline': txt, //rubriken som man klickat på
            'isAuthenticated': String(window.authenticated).charAt(0).toUpperCase() + String(window.authenticated).slice(1).toLowerCase(),
            'selectedBranch': Analytics.getBranchName()
        });
    }

    // Any form with the GA custom element
    static formPosted() {
        this.sendEvent('TF_Form', 'Posted', location.pathname);
    }
    //Invoices
    static downloadInvoice() {
        dataLayer.push({
            'event': 'InvoiceDownload',
            'isAuthenticated': String(window.authenticated).charAt(0).toUpperCase() + String(window.authenticated).slice(1).toLowerCase(),
            'selectedBranch': Analytics.getBranchName()
        });
    }

    //Download file
    static downloadFile(name) {
        dataLayer.push({
            'event': 'fileDownload',
            'pdfName': name,
            'isAuthenticated': String(window.authenticated).charAt(0).toUpperCase() + String(window.authenticated).slice(1).toLowerCase(),
            'selectedBranch': Analytics.getBranchName()
        });

    }

    static newMember(idtype) {
        dataLayer.push({
            'event': 'newMember',
            'MembershipCreateTyp': idtype,
            'isAuthenticated': String(window.authenticated).charAt(0).toUpperCase() + String(window.authenticated).slice(1).toLowerCase(),
            'selectedBranch': Analytics.getBranchName()
        });
    }

    static getBranchName() {
        const branchBtn = document.querySelector('.branch__open');
        if (!branchBtn) return;
        let branchName = branchBtn.innerText;
        return Analytics.formatBranchName(branchName)
    }

    static newMemberPrint() {
        dataLayer.push({
            'event': 'newMemberApplicationPrint',
            'selectedBranch': Analytics.getBranchName()
        });
    }

    static newMemberStepCompleted(step) {
        dataLayer.push({
            'event': 'newMemberCheckoutSteps',
            'checkoutSteps': `Step ${step}`,
            'selectedBranch': Analytics.getBranchName()
        });
    }

    static campaignCtaClick(e) {
        dataLayer.push({
            'event': 'CampaignButtonClick',
            'buttonText': e.currentTarget.innerText,
            'isAuthenticated': String(window.authenticated).charAt(0).toUpperCase() + String(window.authenticated).slice(1).toLowerCase(),
            'selectedBranch': Analytics.getBranchName()
        });
    }
    
    static formatBranchName(name) {
        if (!name) return Analytics.noBranchText;
        if (name.toLowerCase() === 'välj bransch') return Analytics.noBranchText;
        return (name.charAt(0).toUpperCase() + name.slice(1).toLowerCase()).trim();
    }
}


document.addEventListener("DOMContentLoaded", function () {
    function findAnchorTag(element) {
        let target = element
        while (!target.matches('a') && !target.matches('body')) {
            target = target.parentElement;
        }

        return target.matches('a') ? target : null
    }

    const trackedFileTypes = [".pdf", ".doc", ".docx", ".xls", ".xlsx", ".ppt", ".pptx", ".pptm"]
    const downloadLinkQuery = trackedFileTypes.map(type => `a[href*="${type}"]`).join(', ')

    const downloadLinks = document.querySelectorAll(`${downloadLinkQuery}, a[download]`);
    downloadLinks.forEach(link => {
        link.addEventListener("click", (e) => {
            const target = findAnchorTag(e.target)
            if (!target) return;
            let url = new URL(target.href);
            url.search = ""
            let fileName = target.dataset.download || url.toString().split('/').slice(-1).pop(); // last entry, filename.pdf
            Analytics.downloadFile(fileName);
        });
    })


    var bankIdNewMemberLink = document.querySelector('[href^="https://app.assently.com/"]');
    var withoutBankIdNewMemberLink = document.querySelector('[href*="intradeshandlingar.docx"]');
    if (bankIdNewMemberLink) {
        bankIdNewMemberLink.addEventListener('click', () => {
            Analytics.newMember('BankId');

            if (typeof ga !== 'undefined') {
                // ga('send', 'event', 'TF_NewMember', 'BankId', location.pathname);
            }
        });
    }
    if (withoutBankIdNewMemberLink) {
        withoutBankIdNewMemberLink.addEventListener('click', () => {
            Analytics.newMember('WithoutBankId');

            if (typeof ga !== 'undefined') {
                // ga('send', 'event', 'TF_NewMember', 'WithoutBankId', location.pathname);
            }
        });
    }
});

export { Analytics as default };
